module.exports = __webpack_public_path__ + "img/square-phone.a9b9b16e.png";